import { Box } from "@chakra-ui/react";
import { CommandType } from "../types/command.types";

const CommandTypeBadge = ({ type }: { type: CommandType }) => {
	const height = "22px";
	const fontSize = "12px";

	if (type === CommandType.POSTE) {
		return (
			<Box
				width={"fit-content"}
				fontSize={fontSize}
				height={height}
				lineHeight={height}
				px="6px"
				backgroundColor="yellow.50"
				color="yellow.700"
				border={"solid 1px"}
				borderColor="yellow.200"
				rounded="xl"
			>
				Physique
			</Box>
		);
	}
	if (type === CommandType.OTOSCAN) {
		return (
			<Box
				width={"fit-content"}
				textAlign={"center"}
				height={height}
				lineHeight={height}
				fontSize={fontSize}
				px="6px"
				backgroundColor="purple.50"
				color="purple.700"
				border={"solid 1px"}
				borderColor="purple.200"
				rounded="xl"
			>
				Otoscan
			</Box>
		);
	}
	if (type === CommandType.THREED) {
		return (
			<Box
				width={"fit-content"}
				textAlign={"center"}
				height={height}
				lineHeight={height}
				fontSize={fontSize}
				px="6px"
				backgroundColor="brand.50"
				color="brand.700"
				border={"solid 1px"}
				borderColor="brand.200"
				rounded="xl"
			>
				3D
			</Box>
		);
	}
	if (type === CommandType.SUPPLY) {
		return (
			<Box
				width={"fit-content"}
				textAlign={"center"}
				height={height}
				lineHeight={height}
				fontSize={fontSize}
				px="6px"
				backgroundColor="pink.50"
				color="pink.700"
				border={"solid 1px"}
				borderColor="pink.200"
				rounded="xl"
			>
				Fournitures
			</Box>
		);
	}
	if (type === CommandType.REWORK) {
		return (
			<Box
				width={"fit-content"}
				textAlign={"center"}
				height={height}
				lineHeight={height}
				fontSize={fontSize}
				px="6px"
				backgroundColor="#F3FEE7"
				color="#3B7C0F"
				border={"solid 1px"}
				borderColor="#D0F8AB"
				rounded="xl"
			>
				Refonte
			</Box>
		);
	}
	return <>{type}</>;
};

export default CommandTypeBadge;
